import Click from './components/Click';
import Discord from './components/Discord';
import ReliBirds from './components/ReliBirds';
import ReliBirdsEye from './components/ReliBirdsEye';
import Info from './components/Info';
import Lab from './components/Lab';
import Twitter from './components/Twitter';

const Icon = {
  Click,
  Discord,
  ReliBirds,
  ReliBirdsEye,
  Info,
  Lab,
  Twitter,
};

export default Icon;
